import { Injectable, inject } from '@angular/core';

import { DefaultStatesEnum, KeyValueType } from '@models/common';
import { BaseRestrictions } from '@models/module/fields/enums';
import { FilterTextOperators, GridViewModel, SearchViewModel } from '@models/module/grid';
import { OpenDocumentsModel } from '@models/module/openDocuments';
import { DataListCommandFilterType, DisplayFormats, TableColumn } from '@shared/components/data-list/common';
import { HttpService } from '@shared/services';

@Injectable({ providedIn: 'root' })
export class OpenDocumentsTableService {
  private httpService = inject(HttpService);

  getOpenDocuments(searchView: SearchViewModel, entityInstanceId: number) {
    const params = this.httpService.buildHttpParams({ entityInstanceId });
    return this.httpService.post<GridViewModel<OpenDocumentsModel[]>>(`_api/Contracts/SearchDocuments`, searchView, {
      useLoader: false,
      httpOptions: { params },
    });
  }

  getDocumentsModules(entityInstanceId: number) {
    const params = this.httpService.buildHttpParams({ entityInstanceId });
    return this.httpService.get<KeyValueType<number>[]>(`_api/Contracts/GetDocumentsModules`, {
      useLoader: false,
      httpOptions: { params },
    });
  }

  getTableColumns(): TableColumn[] {
    return [
      {
        id: 0,
        name: 'moduleName',
        displayName: 'OPEN_DOCUMENTS.DOC_TABLE.MODULE',
        sortable: true,
        width: 2,
      },
      {
        id: 1,
        name: 'fullDocNum',
        displayName: 'OPEN_DOCUMENTS.DOC_TABLE.FULLDOCNUM',
        sortable: true,
      },
      {
        id: 2,
        name: 'ballInCourtOrgName',
        displayName: 'OPEN_DOCUMENTS.DOC_TABLE.BALLINCOURTORGNAME',
        sortable: true,
      },
      {
        id: 3,
        name: 'subject',
        displayName: 'OPEN_DOCUMENTS.DOC_TABLE.SUBJECT',
        sortable: true,
        width: 3,
      },
      {
        id: 4,
        name: 'state',
        displayName: 'OPEN_DOCUMENTS.DOC_TABLE.STATE',
        sortable: true,
        displayFormatId: DisplayFormats.Status,
        align: 'center',
        width: 1,
      },
      {
        id: 5,
        name: 'submittedOn',
        displayName: 'OPEN_DOCUMENTS.DOC_TABLE.SUBMITTEDON',
        sortable: true,
        displayFormatId: DisplayFormats.Date,
        restrictions: BaseRestrictions.DateTime,
        width: 2,
      },
    ];
  }

  initFilters(modules: KeyValueType<number>[]): DataListCommandFilterType[] {
    return [
      {
        fieldId: 'moduleId',
        name: 'OPEN_DOCUMENTS.DOC_TABLE.MODULE',
        operators: ['Equal', 'NotEqual'],
        selectedOperator: 'Equal',
        multipleSelection: true,
        type: 'text',
        values: modules,
      },
      {
        fieldId: 'stateType',
        name: 'OPEN_DOCUMENTS.DOC_TABLE.STATE_TYPE',
        operators: ['Equal', 'NotEqual'],
        selectedOperator: 'Equal',
        type: 'text',
        multipleSelection: true,
        values: [
          {
            key: `${DefaultStatesEnum.Approved}`,
            value: DefaultStatesEnum[DefaultStatesEnum.Approved],
          },
          {
            key: `${DefaultStatesEnum.Draft}`,
            value: 'Start',
          },
          {
            key: `${DefaultStatesEnum.Open}`,
            value: DefaultStatesEnum[DefaultStatesEnum.Open],
          },
          {
            key: `${DefaultStatesEnum.Rejected}`,
            value: DefaultStatesEnum[DefaultStatesEnum.Rejected],
          },
        ],
      },
      {
        fieldId: 'state',
        name: 'OPEN_DOCUMENTS.DOC_TABLE.STATE',
        operators: FilterTextOperators,
        type: 'text',
      },
      {
        fieldId: 'ballInCourtOrgName',
        name: 'OPEN_DOCUMENTS.DOC_TABLE.BALLINCOURTORGNAME',
        operators: FilterTextOperators,
        type: 'text',
      },
    ];
  }
}
